<template>
<div class="container">
    <v-row v-for="checkpoint in checkpoints" :key="checkpoint.sys.id">
      <checkpoint
        v-if="
        checkpoint.sys.contentType.sys.id.toString() === 'ageInCheckpoint'
        "
        :fields="checkpoint.fields"
        :sysId="checkpoint.sys.id"
        :color="fields.background"
        :title="fields.segmentTitle"
        :firstOneInSeg="(checkpoint===checkpoints[0]) ? true: false"
        :firstOneInGraph="(firstOne && checkpoint===checkpoints[0]) ? true: false"
        :lastOneInSeg="(checkpoint===checkpoints[checkpoints.length - 1]) ? true: false"
        :lastOneInGraph="(lastOne && checkpoint===checkpoints[checkpoints.length - 1]) ? true: false"
      />
    </v-row>
  </div>
</template>

<script>
import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import Checkpoint from './checkpoint'
import { backgroundColorClass, textColorClass, leftBarColorClass } from '@/utils/helpers'

export default {
  name: 'Segment',
  components: {
    Checkpoint
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    sysId: {
      type: String,
      required: true
    },
    firstOne: {
      type: Boolean,
      required: true
    },
    lastOne: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    backgroundColorClass,
    textColorClass,
    leftBarColorClass
  },
  data () {
    return {
      checkpoints: []
    }
  },
  async created () {
    const { items, includes } = await queryCTF(
      `&include=2&content_type=ageInSegment&select.fields&sys.id=${this.sysId}`
    )
    if (items && includes) {
      const group = items[0]
      const entries = includes.Entry.filter((x) =>
        group.fields.checkpoints.find((t) => t.sys.id === x.sys.id)
      )
      const entriesWithImg = entries.map((el) => {
        const img = includes.Asset.find(
          (a) => a.sys.id === el.fields.icon.sys.id
        )
        const ret = { ...el }
        ret.fields.iconUrl = img.fields.file.url
        return ret
      })

      const sortedEntries = await sortCTFEntries(
        group.fields.checkpoints,
        entriesWithImg
      )

      this.checkpoints = sortedEntries
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.background {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}
.row{
  margin-right: 0;
  margin-left:0;
}

.container{
  padding: 0;
}

</style>
